import { useState, useEffect, useRef } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useBgRemoval } from '../utils/useBgRemoval';
import './WelcomeCard.css';

const WelcomeCard = () => {
  const { theme } = useTheme();
  const [visible, setVisible]   = useState(false);
  const [closing, setClosing]   = useState(false);
  const charRef                 = useRef(null);
  const rawSrc  = theme === 'sanjay' ? '/wave_hand.png' : '/image.png';
  const charSrc = useBgRemoval(rawSrc);

  useEffect(() => {
    const seen = sessionStorage.getItem('ebi_welcome_seen');
    if (!seen) {
      const t = setTimeout(() => setVisible(true), 700);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    /* fire fly event BEFORE closing so the assistant can read the rect */
    if (charRef.current) {
      const rect = charRef.current.getBoundingClientRect();
      window.dispatchEvent(new CustomEvent('sa-welcome-fly', { detail: { rect } }));
    }
    setClosing(true);
    setTimeout(() => {
      setVisible(false);
      sessionStorage.setItem('ebi_welcome_seen', 'true');
    }, 400);
  };

  if (!visible) return null;

  return (
    <div className={`wc-overlay ${closing ? 'wc-overlay--out' : ''}`} onClick={dismiss}>
      <div className={`wc-card ${closing ? 'wc-card--out' : ''}`} onClick={e => e.stopPropagation()}>

        <div className="wc-body">
          <div className="wc-left">
            <span className="wc-wave">👋</span>
            <h2 className="wc-title">Welcome back,<br /><span className="wc-name">Raje!</span></h2>
            <p className="wc-sub">Ready to learn something amazing today?</p>
            <button className="wc-btn" onClick={dismiss}>Let's Go! 🚀</button>
          </div>

          <div className="wc-right">
            <img
              ref={charRef}
              src={charSrc}
              alt="Sanjay Sir"
              className="wc-char"
            />
          </div>
        </div>

        <div className="wc-dots">
          <span /><span /><span />
        </div>
      </div>
    </div>
  );
};

export default WelcomeCard;
